import * as React from "react";
import * as ReactDOM from "react-dom";
import { distanceInWords, differenceInCalendarDays, format } from "date-fns";
import * as ru from "date-fns/locale/ru";
import classnames from "classnames";
// import "ckeditor";
import Tooltip from "rc-tooltip";
import * as styles from "./styles.scss";

import {
  Card,
  Switch,
  List,
  Star,
  Input,
  Button,
  Form,
  Popup,
  Badge,
  Icon,
  Dropdown,
} from "../../components";

export class CommentEditor extends React.Component<{
  value?: string;
  onChange?: any;
  homeworkCheck?: boolean;
  onLoad?: any;
  placeholder?: string;
  extended?: boolean;
  newFormats?: boolean;
}> {
  public textarea: any;
  public editor: any;
  private silent: boolean = false;

  componentDidMount() {
    const self = this;

    (window as any).AT.Ckeditor(this.textarea, function() {
      self.editor = this;
      this.focus();
      this.on("change", function() {
        if (!self.silent && self.props.onChange !== undefined) {
          self.props.onChange(this.getData());
        }
      });
      self.textarea.parentNode
        .getElementsByTagName("iframe")[0]
        .removeAttribute("title");
      if (!self.silent && self.props.onLoad !== undefined) {
        self.props.onLoad();
      }
    });
  }

  componentWillUnmount() {
    if (typeof this.editor != "undefined") {
      this.editor.removeAllListeners();
    }
  }

  shouldComponentUpdate(props: any) {
    if (this.editor && this.editor.getData() !== props.value) {
      this.silent = true;
      this.editor.setData(props.value);
      this.silent = false;
    }
    return true;
  }

  inserFileCode(data: string) {
    this.editor.insertText(data);
    return this.editor.getData();
  }

  render() {
    const className = {
      editorModified: classnames({
        [styles.editor]: true,
        [styles.editorAdvanced]:
          this.props.homeworkCheck || this.props.extended,
        [styles.editorExtended]: this.props.extended,
      }),
      ckEditorClassNames: classnames({
        "js-editor": this.props.extended,
        "js-editor-check": !this.props.extended,
        "js-editor-newformats": this.props.newFormats,
      }),
    };

    return (
      <div className={className.editorModified}>
        <div>
          <textarea
            className={className.ckEditorClassNames}
            defaultValue={this.props.value}
            ref={(r) => (this.textarea = r)}
            placeholder={this.props.placeholder}
          />
          <div className="fileupload js-file_uploader" data-action="/panel/files/upload" data-course={document.body.dataset.courseId}>
            <div className="fileupload-list ov-h js-file_uploader__progresses">
                <div className="fileupload-info js-file_uploader__progress">
                    <div className="fileupload-info__label js-file_uploader__label" data-loading="Загрузка файла" data-processing="Обработка файла">Обработка файла</div>
                    <div className="fileupload-info__percents js-file_uploader__percent">0%</div>
                    <div className="fileupload-info__progress js-file_uploader__tooltip wasTooltiped" title="Файл находится в&amp;nbsp;обработке для&amp;nbsp;того, чтобы&amp;nbsp;его можно&amp;nbsp;было посмотреть в&amp;nbsp;любом браузере. Файлы обрабатываются по&amp;nbsp;очереди, время его&amp;nbsp;обработки примерно равно длительности файла. 10&amp;#8209;ти минутное видео обрабатывется примерно 10&amp;nbsp;минут.">
                        <div className="fileupload-info__progress-bar">
                            <div className="current js-file_uploader__bar" ></div>
                        </div>
                    </div>
                    <div className="fileupload-info__cancel js-file_uploader__cancel wasTooltiped" title="Отменить загрузку файла"><img src="/public/images/pix.gif" alt="" className="ic-group ic-group-cancel" /></div>
                </div>
            </div>
        </div>
        </div>
      </div>
    );
  }
}
